module.exports = __webpack_public_path__ + "img/TL-icon-RGB.995afa89.svg";